import { render, staticRenderFns } from "./gytable.vue?vue&type=template&id=523b34db&scoped=true&"
import script from "./gytable.vue?vue&type=script&lang=js&"
export * from "./gytable.vue?vue&type=script&lang=js&"
import style0 from "./gytable.vue?vue&type=style&index=0&id=523b34db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b34db",
  null
  
)

export default component.exports